export function urlCruise(pathname?: string | null | undefined) {
  if (!pathname) {
    return '/cruzeiros';
  }

  if (pathname?.startsWith('https')) {
    return pathname;
  }
  let path = pathname.replace('/cruzeiros', '').replace(/^\//g, '').trim();
  return `/cruzeiros/${path}`;
}
